import React from 'react'

const BetContext = React.createContext({
  type: ''
})

export default BetContext
